<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<el-input v-model="name" placeholder="请输入姓名" suffix-icon="el-icon-search" style="width: 200px;" size="small"
				@keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row style="width: 100%" max-height="1000">
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="name" align="center" label="名称" width="180">
			</el-table-column>
			<el-table-column prop="apart" align="center" label="部门" width="180">
			</el-table-column>
			<el-table-column prop="address" align="center" label="地址" width="300">
			</el-table-column>
			<el-table-column prop="yq" align="center" label="要求">
			</el-table-column>


			<el-table-column prop="operate" align="center" label="操作" width="180">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row)">编辑</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)" style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="60%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px">

				<el-form-item label="名称(中文)" prop="name">
					<el-col :span="20">
						<el-input v-model="form.name"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="名称(英文)" prop="nameEg">
					<el-col :span="20">
						<el-input v-model="form.nameEg"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="部门(中文)" prop="apart">
					<el-col :span="20">
						<el-input v-model="form.apart"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="部门(英文)" prop="apartEg">
					<el-col :span="20">
						<el-input v-model="form.apartEg"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="地址(中文)" prop="address">
					<el-col :span="20">
						<el-input v-model="form.address"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="地址(英文)" prop="addressEg">
					<el-col :span="20">
						<el-input v-model="form.addressEg"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="要求(中文)" prop="yq">
					<el-col :span="20">
						<el-input v-model="form.yq"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="要求(英文)" prop="yqEg">
					<el-col :span="20">
						<el-input v-model="form.yqEg"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="详情(中文)" prop="detail">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.detail" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="详情(英文)" prop="detailEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.detailEg" :init="initEditor" />
					</el-col>
				</el-form-item>



			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				rules: {
					title: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				options: [],
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				title: "",
				name: "",
				centerDialogVisible: false,
				form: {
					name: "",
					nameEg: "",
					apart: "",
					apartEg: "",
					address: "",
					addressEg: "",
					detail: "",
					detailEg: "",
					yq: "",
					yqEg: ""
				},
				btnText: "提 交",
				textTitle: "新增案例",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				options1: [{
					value: '管理团队',
					label: '管理团队'
				}, {
					value: '工程师',
					label: '工程师'
				}, {
					value: '销售团队',
					label: '销售团队'
				}],
				options2: [{
					value: 'Leadership',
					label: 'Leadership'
				}, {
					value: 'Engineering',
					label: 'Engineering'
				}, {
					value: 'Product',
					label: 'Product'
				}],
			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			// this.loadPost();
		},
		methods: {
			handleAvatarSuccess(res, file) {
				this.form.head = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			mod(row) {
				this.form = row;
				this.btnText = "保存";
				this.textTitle = '修改信息'
				this.centerDialogVisible = true;
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.utils.requestPost(this, "/zhiwei/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.utils.requestPost(this, "/zhiwei/mod", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加信息'
				this.centerDialogVisible = true;
				this.form = {
					name: "",
					nameEg: "",
					apart: "",
					apartEg: "",
					address: "",
					addressEg: "",
					detail: "",
					detailEg: "",
					yq: "",
					yqEg: ""
				};
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name
					}
				};
				this.utils.requestPost(this, "/zhiwei/getZhiweiList", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			},
			deleteRow(row) {
				var that = this;
				var params = {
					"id": row.id
				};
				this.utils.requestPost(this, "/zhiwei/delete", params, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
